import {useNavigate, useLocation} from 'react-router-dom';
import Illustration from '@cvent/carina/components/Illustration';
import {Button} from '@cvent/carina/components/Button';

const DEFAULT_TITLE = 'Something went wrong';
const DEFAULT_DESCRIPTION =
  'Try again later. For assistance, contact support at';

export interface GenericErrorLocationState {
  errorCode?: number | null;
  errorPageReturnPath?: string | null;
  title?: string;
  description?: string;
}

export function GenericError(props: GenericErrorLocationState = {}) {
  const navigate = useNavigate();
  const {state} = useLocation() as {state: GenericErrorLocationState | null};

  const errorCode = state?.errorCode ?? props.errorCode ?? 500;
  const errorPageReturnPath =
    state?.errorPageReturnPath ?? props.errorPageReturnPath ?? '/login';
  const title = state?.title ?? props.title ?? DEFAULT_TITLE;
  const description =
    state?.description ?? props.description ?? DEFAULT_DESCRIPTION;

  function handleClick() {
    return navigate(errorPageReturnPath);
  }

  return (
    <div className="px-4 md:px-0 h-full max-w-lg mx-auto flex flex-col justify-center items-center">
      <Illustration
        aria-hidden
        className="size-[375px]"
        title="error-illustration"
        name="unsynced"
      />
      <div className="leading-4 flex flex-col items-center">
        <div className="text-body-lg font-bold mb-2">{title}</div>
        <div className="text-center mb-4 text-body-md text-soft">
          <div>{description}</div>
          <a className="no-underline" href="mailto:ST.support@cvent.com">
            ST.support@cvent.com
          </a>
          .
        </div>
        <div className="mb-4">
          <Button text="Go back" onClick={handleClick} appearance="filled" />
        </div>
        {errorCode !== 404 ? (
          <div className="text-body-2xs text-soft">Error code: {errorCode}</div>
        ) : null}
      </div>
    </div>
  );
}
